export type PresetterMode = 'XPL' | 'XNL' | 'XPR' | 'XNR';

export interface ModeConfig {
  label: string;
  description: string;
  dParams: [string, string, string, string];
}

export const PRESETTER_MODES: Record<PresetterMode, ModeConfig> = {
  XPL: {
    label: 'X+ Left',
    description: 'X Positive, Left Side',
    dParams: ['D1558', 'D1559', 'D1560', 'D1561']
  },
  XNL: {
    label: 'X- Left',
    description: 'X Negative, Left Side',
    dParams: ['D1554', 'D1555', 'D1556', 'D1557']
  },
  XPR: {
    label: 'X+ Right (Sub)',
    description: 'X Positive, Right Side (Sub Spindle)',
    dParams: ['D1574', 'D1575', 'D1576', 'D1577']
  },
  XNR: {
    label: 'X- Right (Sub)',
    description: 'X Negative, Right Side (Sub Spindle)',
    dParams: ['D1570', 'D1571', 'D1572', 'D1573']
  }
};

export const DEFAULT_BYTE_2 = '00000100';
export const DEFAULT_BYTE_3 = '00000000';

export const HISTORY_STORAGE_KEY = 'moriseiki-presetter-history';
export const THEME_STORAGE_KEY = 'moriseiki-presetter-theme';
export const MAX_HISTORY_ITEMS = 20;
